export default {
  /**
   * 网页标题
   */
  title: import.meta.env.VITE_APP_TITLE,
  /**
   * 公開無料版ダッシュボードの「お問い合わせ」連絡先メールアドレス
   * 実際の読み取り/有効性チェックは src/utils/contact.js に集約
   */
  contactEmail: import.meta.env.VITE_APP_CONTACT_EMAIL,
  /**
   * ログイン成功後の既定遷移先（いわゆるホームパス）。
   * ルートパス('/')のリダイレクト・ログアウト・セッション切れ再ログイン でも同じパスを使用する。
   * 遷移先を変えたい場合はここだけ書き換える（実際のルート定義は src/router/index.js）。
   */
  homePath: '/index',
  /**
   * 侧边栏主题 深色主题theme-dark，浅色主题theme-light
   */
  sideTheme: 'theme-light',
  /**
   * 是否系统布局配置
   */
  showSettings: true,

  /**
   * 是否显示顶部导航
   */
  topNav: false,

  /**
   * 是否显示 tagsView
   */
  tagsView: true,

  /**
   * 是否固定头部
   */
  fixedHeader: false,

  /**
   * 是否显示logo
   */
  sidebarLogo: true,

  /**
   * 是否显示动态标题
   */
  dynamicTitle: false,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
}
